class TextOnAssetList extends HTMLElement {
  constructor() {
    super();
    this.items = [];

  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.text-on-asset-list__item'));
    // this.initScrollAnimation();
  }

  initScrollAnimation() {
    gsap.set(this.items, {
      y: 50,
      opacity: 0,
      scale: 0.95
    });

    this.items.forEach((item, index) => {
      gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top bottom-=50',
          end: 'top center',
          scrub: true
        },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: 'power2.out'
      });
    });
  }
}

customElements.define('text-on-asset-list', TextOnAssetList);